module.exports = __webpack_public_path__ + "img/icon-download.ef712b62.svg";